
import FileTransformer from '../../transformers/Files/Files'
import Vue from 'vue'

export default (payload) => {
  const tData = FileTransformer.send(payload)

  return Vue.$http.delete(`/catalogs/common/file/${payload.id}/`, tData)
}



// WEBPACK FOOTER //
// ./src/services/Files/delete.js